import { createActionConst } from '../../../utils/action.utils';

const NOTIFICATION_NAMESPACE = 'NOTIFICATION';

export const STORE_NOTIFICATION = createActionConst(NOTIFICATION_NAMESPACE, 'STORE_NOTIFICATION');
export const CLEAR_NOTIFICATION = createActionConst(NOTIFICATION_NAMESPACE, 'CLEAR_NOTIFICATION');
